import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { PROJECTS } from '../services/projects.services';

const DeliverySummary = ({
  totalValue,
  totalSuffix,
  isShowIcon = true,
  isIterationView = false,
  icon,
  title
}) => {
  return (
    <Flex items='center'>
      {isShowIcon && icon && (
        <Icon
          name={icon}
          isThin={true}
          size={isIterationView ? 'x-large' : 'large'}
          color='shark'
          data-testid='delivery-summary-icon'
        />
      )}

      {isIterationView ? (
        <Flex ml='small' mr='small' items='baseline'>
          <Text size='x-large' data-testid='delivery-value'>
            {totalValue}
            {totalSuffix}
          </Text>
          <Text
            color={PROJECTS.SECONDARY_COLOR}
            size='small'
            data-testid='delivery-summary-text'
            pl='0.5rem'
          >
            {title}
          </Text>
        </Flex>
      ) : (
        <Flex direction='column' ml='small' mr='x-x-small'>
          <Text size='large' mb='0.3rem' data-testid='delivery-value'>
            {totalValue}
            {totalSuffix}
          </Text>
          <Text
            color={PROJECTS.SECONDARY_COLOR}
            width='7.1rem'
            data-testid='delivery-summary-text'
          >
            {title}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default DeliverySummary;
